import React from "react";
import Header from "./Shared/Header/Header";
import AppRouting from "./AppRouting";
import Footer from "./Shared/Footer/Footer";
import Sidebar from "./Shared/Sidebar";

const Layout = ({ benchId, benchName, benchCode }) => {
  return (
    <>
      <Header benchId={benchId} benchName={benchName} benchCode={benchCode} />
      <div className="main-center-area">
        <div className="container-fluid">
          <div className="row">
            <Sidebar benchId={benchId} calendarId={benchId} />
            <AppRouting benchId={benchId} benchName={benchName} />
          </div>
        </div>
      </div>
      <Footer benchId={benchId} />
    </>
  );
};

export default Layout;
